export default __webpack_public_path__ + "static/media/single-02-kitchen-inactive.3dc5a755.webp";